import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app.js'
import config from './modules/config.js'
import notifier from './modules/notifier.js'
import user from './modules/user.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    app,
    config,
    notifier,
    user
  },
  strict: debug
})
